import { Label } from 'components/atoms';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { PiHandCoinsBold, PiReceiptFill } from 'react-icons/pi';
import { INCOME_TYPE } from 'services/cash-flow/income/types';
import { IColorProp } from 'types/components/components.interface';

export interface ILabeledStatusProps {
  status: INCOME_TYPE;
}

interface ILabeledStatusParams extends IColorProp {
  status: INCOME_TYPE;
  icon: ReactNode;
}

const labeledStatusParams: ILabeledStatusParams[] = [
  {
    status: INCOME_TYPE.cost,
    color: 'red',
    icon: <PiReceiptFill />,
  },
  {
    status: INCOME_TYPE.basic,
    color: 'blue',
    icon: <PiHandCoinsBold />,
  },
  {
    status: INCOME_TYPE.repaysAdvance,
    color: 'blue',
    icon: <PiHandCoinsBold />,
  },
  {
    status: INCOME_TYPE.repaysCost,
    color: 'blue',
    icon: <PiHandCoinsBold />,
  },
];

const LabeledIncomeStatus = ({ status }: ILabeledStatusProps) => {
  const { t } = useTranslation();
  const labeledParams =
    labeledStatusParams.find(params => params.status === status) ??
    labeledStatusParams[0];

  return (
    <Label
      size='compact'
      color={labeledParams.color}
      title={t(`${labeledParams.status}`)}>
      {labeledParams.icon}{' '}
      {t(`enum.INCOME_TYPE.${INCOME_TYPE[labeledParams.status]}`)}
    </Label>
  );
};

export default LabeledIncomeStatus;
